import React, { useState } from "react";
import "./S5VI.css";

const faqs = [
  {
    q: "How much does it cost to sell on Maplee?",
    a: (
      <>
        There are no upfront costs to sell on Maplee. We only charge a 10% commission on each sale.
      </>
    ),
  },
  {
    q: "How do order fulfillment and shipping work?",
    a: (
      <>
        We provide tools for generating packing slips, managing shipments, and
        creating invoices. You can connect your preferred carriers and print
        labels right from the dashboard.
      </>
    ),
  },
  {
    q: "How and when do I get paid?",
    a: (
      <>
        Payouts are deposited directly to your bank account on the payout
        schedule you choose, after orders are confirmed as delivered.
      </>
    ),
  },
  {
    q: "Can I use Maplee if I already have reps?",
    a: (
      <>
        Yes. Maplee works alongside your existing sales channels—use it to
        streamline invoicing, payment collection, and order tracking.
      </>
    ),
  },
  {
    q: "Which provinces are currently supported on Maplee?",
    a: (
      <>
        We support sellers across Canada (more regional support coming soon).
      </>
    ),
  },
];

export default function S5VI() {
  // null = all collapsed on first render
  const [openIdx, setOpenIdx] = useState(null);

  const toggle = (idx) => {
    setOpenIdx((prev) => (prev === idx ? null : idx));
  };

  return (
    <section className="s5vi" aria-labelledby="s5vi-title">
      <div className="s5vi-wrap">
        <h2 id="s5vi-title" className="s5vi-title">
          You may be wondering
        </h2>

        <ol className="s5vi-list">
          {faqs.map((item, idx) => {
            const isOpen = openIdx === idx;
            return (
              <li key={idx} className="s5vi-item">
                <button
                  type="button"
                  className="s5vi-q"
                  aria-expanded={isOpen ? "true" : "false"}
                  aria-controls={`s5vi-a-${idx}`}
                  id={`s5vi-q-${idx}`}
                  onClick={() => toggle(idx)}
                >
                  <span>{item.q}</span>

                  {/* Filled caret (▼) rendered via inline SVG */}
                  <svg
                    className="s5vi-caret"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path d="M6 9l6 6 6-6z" />
                  </svg>
                </button>

                <div
                  id={`s5vi-a-${idx}`}
                  role="region"
                  aria-labelledby={`s5vi-q-${idx}`}
                  className={`s5vi-a ${isOpen ? "is-open" : ""}`}
                >
                  <div className="s5vi-a-inner">{item.a}</div>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
